export class Settings {
    private static beUrl: string = import.meta.env.VITE_BACKEND_BASE_URL as string;

    public static backEndBaseUrl(): string {
        console.log("Backend base URL:", Settings.beUrl);
        return Settings.beUrl as string;
    }
}